// @ts-nocheck
import { getDocument, RfqDetailsDocumentParameter } from "@store/Framework/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Props = {
    apiParameter: RfqDetailsDocumentParameter;
};

type HandlerType = Handler<RfqDetailsDocumentParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = props => {
    getDocument(props.apiParameter);
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const getQuoteDetailsDocument = createHandlerChainRunner(chain, "GetQuoteDetailsDocument");
export default getQuoteDetailsDocument;
